import {
  alert
} from '../constants';

/**
   * Import constants
   */
const {
  SET_MODAL_TYPE,
  SET_IS_MODAL_OPEN,
  SET_MODAL_CONFIRM_ACTION,
  SET_MODAL_ALERTING_MESSAGE,
  SET_SHOW_NATIONAL_SURVEY_PROMPT
} = alert;

const actions = {
  setModalType: (data) => ({ type: SET_MODAL_TYPE, data }),
  setIsModalOpen: (data) => ({ type: SET_IS_MODAL_OPEN, data }),
  setModalConfirmAction: (data) => ({ type: SET_MODAL_CONFIRM_ACTION, data }),
  setModalAlertingMessage: (data) => ({ type: SET_MODAL_ALERTING_MESSAGE, data }),
  setShowNationalSurveyPropmt: (data) => ({ type: SET_SHOW_NATIONAL_SURVEY_PROMPT, data }),
};

export const setModalType = (modalType) => (dispatch) => {
  dispatch(actions.setModalType(modalType));
};

export const setIsModalOpen = (isModalOpen) => (dispatch) => {
  dispatch(actions.setIsModalOpen(isModalOpen));
};

export const setModalAlertingMessage = (modalAlertingMessage) => (dispatch) => dispatch(
  actions.setModalAlertingMessage(modalAlertingMessage)
);

export const setModalConfirmAction = (modalConfirmAction) => (dispatch) => dispatch(
  actions.setModalConfirmAction(modalConfirmAction)
);

export const setShowNationalSurveyPropmt = (isShowNationalSurveyPropmt) => (dispatch) => dispatch(
  actions.setShowNationalSurveyPropmt(isShowNationalSurveyPropmt)
);
